/** La bandada (skein en vuelo): momento de marca. `once` = una pasada.
    El glifo del pájaro lo pone el sistema por JS en los prototipos (login.html:75); aquí va en el markup. */
const BIRD = "M1 9 C5 3, 9 3, 12 8 C15 3, 19 3, 23 9";
export function Flight({ contained, once, duration = "22s", birds = 7, className }: { contained?: boolean | undefined; once?: boolean | undefined; duration?: string | undefined; birds?: number | undefined; className?: string | undefined }) {
  const cls = ["sk-flight", contained && "sk-flight--contained", once && "sk-flight--once", className].filter(Boolean).join(" ");
  return (
    <div className={cls} aria-hidden="true" style={{ ["--sk-flight-dur" as string]: duration }}>
      <div className="sk-flock">
        {Array.from({ length: birds }, (_, i) => (
          <span className="sk-bird" key={i}>
            <svg viewBox="0 0 24 12" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><path d={BIRD} /></svg>
          </span>
        ))}
      </div>
    </div>
  );
}
